import React, { useEffect, useState } from 'react'

const invalidInput = 'is-invalid'
const validInput = 'is-valid'
const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const EmailInput = ({ value, onChange, readOnly = false }) => {
  
  const handleChange = (event) => {
    const email = event.target.value
    const isValid = validate(email)
    if (onChange) {
      onChange(email, isValid)
    }
  }

  const [emailValidClass, setValidityClass] = useState('')
  const [emailErrorMessage, setErrorMessage] = useState('')
  const validate = (value) => {
    let isValid = true
    if (!value) {
      setErrorMessage('Required');
      isValid = false;
    } else if (value.length > 320) {
      setErrorMessage('Max 320 characters');
      isValid = false;
    } else if (!emailRegex.test(String(value).toLowerCase())) {
      setErrorMessage('Please provide a valid email address');
      isValid = false;
    }

    if (isValid) {
      setValidityClass(validInput)
    } else {
      setValidityClass(invalidInput)
    }
    return isValid
  }

  return(
    <React.Fragment>
      <div className="form-group">
        <label htmlFor="email">Email Address</label>
        <input id="email" 
              type="email" 
              name="email" 
              className={`form-control ${emailValidClass}`}
              onChange={ handleChange } 
              required 
              value={ value } 
              readOnly={ readOnly } 
              disabled={ readOnly } 
              maxLength="320" 
              aria-describedby="email-validation-message"
              data-testid="edit-user-email"/>
      </div>
      { emailValidClass === invalidInput &&
        <div id="email-validation-message" 
            className="invalid-feedback"
            style={{ 
              display: 'block',
              marginLeft: '230px'
                    }}>
          { emailErrorMessage }
        </div>     
      }
    </React.Fragment>
  )
}

export default EmailInput